import React, { forwardRef } from 'react';

interface AnswerInputProps {
  value: string;
  onChange: (value: string) => void;
  onKeyPress: (e: React.KeyboardEvent) => void;
  onSubmit: () => void;
  status: 'correct' | 'incorrect' | null;
}

const AnswerInput = forwardRef<HTMLInputElement, AnswerInputProps>(
  ({ value, onChange, onKeyPress, onSubmit, status }, ref) => {
    const getBorderColor = () => {
      if (status === 'correct') return 'border-green-500 dark:border-green-400';
      if (status === 'incorrect') return 'border-red-500 dark:border-red-400';
      return 'border-slate-300 dark:border-slate-600 focus-within:border-indigo-500 dark:focus-within:border-indigo-400';
    };

    return (
      <div className="flex flex-col sm:flex-row items-center gap-3">
        <div className={`flex-1 flex items-center border ${getBorderColor()} rounded-lg overflow-hidden transition-colors`}>
          <input
            ref={ref}
            type="number"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onKeyPress={onKeyPress}
            className="flex-1 px-4 py-3 text-xl bg-white dark:bg-slate-700 text-slate-900 dark:text-slate-100 focus:outline-none"
            placeholder="Enter your answer"
            disabled={status !== null}
          />
        </div>
        <button
          onClick={onSubmit}
          disabled={value.trim() === '' || status !== null}
          className="w-full sm:w-auto px-6 py-3 bg-indigo-600 dark:bg-indigo-500 text-white rounded-lg 
            hover:bg-indigo-700 dark:hover:bg-indigo-600 
            focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:focus:ring-indigo-400 focus:ring-offset-2
            disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          Submit
        </button>
      </div>
    );
  }
);

export default AnswerInput;